export default __webpack_public_path__ + "static/media/portfolio-simple-2-p5.e86a9f21.jpg";